import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingIndicatorService {
  private _loading = new BehaviorSubject<boolean>(false);
  private _isLoading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable();
  public readonly isLoadingt$ = this._loading.asObservable();

  show() {
    this._loading.next(true);
  }

  hide() {
    this._loading.next(false);
  }
  showGet() {
    this._isLoading.next(true);
  }
  hideGet() {
    this._isLoading.next(false);
  }
}
